import { Chip, Colors, Text } from 'library';
import { AvailableTeacher } from 'models';
import { WorkerAvatar } from 'parent-portal/providers/cards/shared/WorkerAvatar';
import React from 'react';
import { Grid, styled, useMediaQuery } from '@mui/material';
import theme from 'theme';

export default function AvailableTeacherCardHeader({ worker }: { worker: AvailableTeacher }) {
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const avatarSize = small ? 80 : 100;
    const credentials = worker.credentials.education
        .concat(worker.credentials.experience)
        .concat(worker.credentials.highlights)
        .filter(Boolean);
    return (
        <Header container>
            <Row container>
                <SideSection small={small}>
                    <WorkerAvatar src={worker.pictureUrl} width={avatarSize} height={avatarSize} />
                </SideSection>
                <MiddleSection small={small}>
                    <Text bold variant="h1" textStyle={{ marginBottom: 4 }}>
                        {worker.name}
                    </Text>
                    {credentials.map((credential) => (
                        <Chip
                            key={credential}
                            label={credential}
                            backgroundColor={Colors.turquoise}
                            textColor={Colors.white}
                            style={{ width: 'fit-content', margin: 5 }}
                        />
                    ))}
                </MiddleSection>
            </Row>
        </Header>
    );
}

const Header = styled(Grid)(() => ({
    backgroundColor: Colors.lightTurq,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    padding: 10,
}));

const SideSection = styled(Grid)(({ small }: { small: boolean }) => ({
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: small ? '36%' : '20%',
}));

const MiddleSection = styled(Grid)(({ small }: { small: boolean }) => ({
    flexDirection: small ? 'row' : 'column',
    width: small ? '64%' : '80%',
    gap: 10,
}));

const Row = styled(Grid)({
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'row',
});
